import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _EditLightBig(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M16.846 2.914c.36 0 .653.152.916.353.251.191.529.47.852.794l1.325 1.325c.324.323.603.6.794.852.2.263.353.556.353.916s-.152.653-.353.915c-.191.252-.47.53-.794.853L9.285 19.577c-.176.176-.327.332-.517.44-.191.109-.404.157-.645.217l-4.192 1.05c-.165.04-.343.086-.492.1-.154.016-.415.012-.625-.198-.209-.209-.213-.47-.198-.625.015-.148.06-.326.102-.49l1.049-4.193c.06-.241.108-.454.216-.645.109-.19.265-.341.44-.517L15.079 4.06c.324-.324.601-.603.853-.794.262-.2.555-.353.915-.353ZM14 5l5 5" })));
}
const EditLightBig = forwardRef(_EditLightBig);
export { EditLightBig };
